import { ContentId } from './content-block';

export type ContentChild = Readonly<{
    id: ContentId; // reference into state properties for headings, checkpoints, functionalElements
    type: CONTENT_TYPE;
}>;

export enum CONTENT_TYPE {
    HEADING,
    CHECKPOINT,
    FUNCTIONAL,
    CONTENT, // topic in cosima
}
